module.exports = __webpack_public_path__ + "static/ProServices-hero-e942d6fd757bbd1570246f6aa2dca98a.png";